import yaml from 'js-yaml';
import { configSchema, type WallpaperConfig } from './schema';

export type LoadResult =
  | { ok: true; config: WallpaperConfig; raw: unknown }
  | { ok: false; error: string; issues?: string[]; raw?: unknown };

export function parseYamlConfig(yamlText: string): LoadResult {
  let raw: unknown;
  try {
    raw = yaml.load(yamlText);
  } catch (e) {
    return { ok: false, error: `YAML parse error: ${(e as Error).message}` };
  }
  const parsed = configSchema.safeParse(raw ?? {});
  if (!parsed.success) {
    const issues = parsed.error.issues.map(
      (i) => `${i.path.join('.') || '(root)'}: ${i.message}`,
    );
    return { ok: false, error: 'config validation failed', issues, raw };
  }
  return { ok: true, config: parsed.data, raw };
}

export async function loadConfigFromUrl(url: string): Promise<LoadResult> {
  const res = await fetch(url, { cache: 'no-cache' });
  if (!res.ok) {
    return { ok: false, error: `failed to fetch ${url}: ${res.status} ${res.statusText}` };
  }
  return parseYamlConfig(await res.text());
}

export function decodeBase64Yaml(b64: string): string {
  const normalized = b64.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(normalized);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder('utf-8').decode(bytes);
}
